import { useCallback } from 'react';

export const useGoTo = () =>
    useCallback((url: string) => {
        window.location.replace(url);
    }, []);
